export default {
  apiKey: 'AIzaSyAOBdZMBttQwzKPbHpuvBKGOIXirYh2L2c',
  authDomain: 'api-6139531463088012290-314793.firebaseapp.com',
  databaseURL: 'https://api-6139531463088012290-314793.firebaseio.com',
  projectId: 'api-6139531463088012290-314793',
  storageBucket: 'api-6139531463088012290-314793.appspot.com',
  messagingSenderId: '406513735464',
  appId: '1:406513735464:web:b5fee9583cf66e03c0a21d'
};
